/**
 * Vanuatu vatu.
 */
export var VUV = {
  code: 'VUV',
  base: 10,
  exponent: 0
};